'use client'

// src/useWindowResize.ts
import { useEffect, useState } from "react";
var useWindowResize = ({ width = 0, height = 0 } = {}) => {
  const initialWidth = typeof window !== "undefined" ? window.innerWidth : 0;
  const initialHeight = typeof window !== "undefined" ? window.innerHeight : 0;
  const [state, setState] = useState({ width: initialWidth, height: initialHeight });
  useEffect(() => {
    const handler = () => {
      const { innerWidth, innerHeight } = window;
      if (state.width !== innerWidth || state.height !== innerHeight) {
        setState({
          width: innerWidth,
          height: innerHeight
        });
      }
    };
    handler();
    window.addEventListener("resize", handler, {
      capture: false,
      passive: true
    });
    return () => {
      window.removeEventListener("resize", handler);
    };
  }, []);
  return {
    width: state.width,
    height: state.height,
    isLessWidth: state.width <= width,
    isLessHeight: state.height <= height
  };
};

export {
  useWindowResize
};
//# sourceMappingURL=chunk-WLUOMJON.mjs.map